import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { StatusBadge, PlaceholderFrame } from "./common";

export const ProductCard = ({ product: p, testId, compact = false }) => (
    <Link
        to={`/portfolio/${p.slug}`}
        data-testid={testId}
        className="group block bg-thg-surface border border-thg-border hover:bg-thg-surfacehover hover:border-[#404040] transition-colors duration-300"
    >
        {p.image ? (
            <div className="relative overflow-hidden border-b border-thg-border">
                <img
                    src={p.image}
                    alt={`${p.name} product interface`}
                    className="w-full aspect-[16/9] object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                    loading="lazy"
                />
                <div
                    className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                    style={{ background: "radial-gradient(560px circle at 50% 0%, rgba(255,255,255,0.09), transparent 65%)" }}
                    aria-hidden="true"
                />
                <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_70px_rgba(0,0,0,0.5)]" aria-hidden="true" />
            </div>
        ) : (
            <PlaceholderFrame label={p.name} />
        )}
        <div className={compact ? "p-8" : "p-8 md:p-10"}>
            <div className="flex flex-wrap items-center gap-3">
                <StatusBadge testId={`product-status-${p.slug}`}>{p.status}</StatusBadge>
                <span className="text-xs tracking-[0.15em] uppercase text-thg-tertiary">{p.division}</span>
            </div>
            <h3 className={`mt-5 font-display font-medium text-white ${compact ? "text-xl md:text-2xl" : "text-2xl md:text-3xl"}`}>
                {p.name}
                {p.aka && (
                    <span className="block text-base text-thg-tertiary mt-1 font-sans tracking-wide">{p.aka}</span>
                )}
            </h3>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-thg-secondary">{p.summary}</p>
            <span className="mt-6 inline-flex items-center gap-2 text-sm text-thg-secondary group-hover:text-white transition-colors duration-300">
                View product
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </span>
        </div>
    </Link>
);
